import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { EnvironmentService } from "./environment.service";

export interface RequestOptions {
  observe?: "body";
  params?: HttpParams | { [param: string]: string | string[] };
  reportProgress?: boolean;
  responseType?: "json";
  withCredentials?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class HttpOrdasClientService {
  private authHeaders: { headers: HttpHeaders };

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  private get endpoint(): string {
    return this.environmentService.get("ordas_api.url") || "";
  }

  public get(url: string, options: RequestOptions = {}): Observable<any> {
    return this.ensureAuthorization().pipe(
      mergeMap(() => {
        const all_ops = Object.assign({}, this.authHeaders, options);
        return this.http.get(this.endpoint + url, all_ops);
      })
    );
  }

  public post(url: string, body: any, options: RequestOptions = {}): Observable<any> {
    return this.ensureAuthorization().pipe(
      mergeMap(() => {
        const all_ops = Object.assign({}, this.authHeaders, options);
        return this.http.post(this.endpoint + url, body, all_ops);
      })
    );
  }

  private ensureAuthorization(): Observable<any> {
    return new Observable((observer) => {
      if (!this.authHeaders) {
        const access_token = localStorage.getItem("access_token");
        this.authHeaders = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${  access_token}`,
          }),
        };
      }
      observer.next();
      observer.complete();
      return;
    });
  }
}
